import { Roles, RoleName } from './Roles';
import { Role } from './Role';
import { IUser } from 'common/schema/User';
import { PermissionsType } from './Permissions';

export class RolesLogic {
  /** Elenco dei ruoli disponibili per la selezione lato Backend */
  static getAdminRoles() {
    return [
      Roles.Admin,
      Roles.Manager,
      Roles.System,
      Roles.Commissioner,
      Roles.Consultant,
      Roles.AOOAdmin
    ];
  }

  static isAdminRole(role: RoleName) {
    return this.getAdminRoles().some(r => r.name === role);
  }

  static getAdminRoleOptions() {
    return this.getAdminRoles().map(role => ({
      value: role.name,
      label: role.displayName,
      children: role.displayName
    }));
  }

  static get(role?: keyof typeof Roles) {
    if (!role) return null;
    return Roles[role];
  }

  static has(user: IUser | null | undefined, permission: PermissionsType) {
    return this.get(user?.role)?.hasPermission(permission);
  }
}
